import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'
import { getProvider } from '@/apollo'

const TariffOptionsModule = {
  namespaced: true,
  state: {
    processId: null,
    bookedOptionUpdateTriggerValue: 0,
    roamingCountries: [],
    euRoamingCountries: []
  },
  actions: {
    async bookTariffoption ({ commit, state, getters, rootGetters }, { tariffoptionId }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation tariffOptions ($bookTariffoptionInput: BookTariffoptionInput!) {
          bookTariffoption (bookTariffoption: $bookTariffoptionInput){
            success,
            processId,
            bookTariffoptionDocumentUrl
          }
        }`,
        variables: {
          bookTariffoptionInput: {
            tariffoptionId: tariffoptionId
          }
        }
      }).then((response) => {
        commit('processId', response.data.bookTariffoption.processId)
        return response.data.bookTariffoption
      }).catch((error) => {
        commit('processId', null)
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async confirmBookTariffoption ({ commit, state, getters, rootGetters }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient

      return apolloClient.mutate({
        mutation: gql`mutation tariffOptions ($confirmTariffoptionBookingInput: ConfirmTariffoptionBookingInput!) {
          confirmTariffoptionBooking (confirmTariffoptionBooking: $confirmTariffoptionBookingInput){
            success
          }
        }`,
        variables: {
          confirmTariffoptionBookingInput: {
            processId: state.processId
          }
        }
      }).then((response) => {
        if (response.data.confirmTariffoptionBooking.success) {
          commit('incBookedOptionUpdateTriggerValue')
        }
        return response.data.confirmTariffoptionBooking
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async cancelTariffoption ({ commit, state, getters, rootGetters }, { tariffoptionId }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation tariffOptions ($initiateCancelTariffoptionInput: InitiateCancelTariffoptionInput!) {
          initiateCancelTariffoption (initiateCancelTariffoption: $initiateCancelTariffoptionInput){
            success,
            processId,
            cancelTariffoptionDocumentUrl
          }
        }`,
        variables: {
          initiateCancelTariffoptionInput: {
            tariffoptionId: tariffoptionId
          }
        }
      }).then((response) => {
        commit('processId', response.data.initiateCancelTariffoption.processId)
        return response.data.initiateCancelTariffoption
      }).catch((error) => {
        commit('processId', null)
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async confirmCancelTariffoption ({ commit, state, getters, rootGetters }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient

      return apolloClient.mutate({
        mutation: gql`mutation tariffOptions ($confirmCancelTariffoptionInput: ConfirmCancelTariffoptionInput!) {
          confirmCancelTariffoption (confirmCancelTariffoption: $confirmCancelTariffoptionInput){
            success
          }
        }`,
        variables: {
          confirmCancelTariffoptionInput: {
            processId: state.processId
          }
        }
      }).then((response) => {
        if (response.data.confirmCancelTariffoption.success) {
          commit('incBookedOptionUpdateTriggerValue')
        }
        return response.data.confirmCancelTariffoption
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async confirmRevokeTariffoption ({ commit, state, getters, rootGetters }, { tariffoptionId }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation revokeTariffoption($tariffoptionId: String!) {
          revokeAboOptionCancel(tariffoptionId: $tariffoptionId) {
            success
          }
        }`,
        variables: {
          tariffoptionId: tariffoptionId
        }
      }).then((response) => {
        if (response.data.revokeAboOptionCancel.success) {
          commit('incBookedOptionUpdateTriggerValue')
        }
        return response.data.revokeAboOptionCancel
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async addOptionalService ({ commit, state, getters, rootGetters }, { serviceOptionId }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation addOptionalService($addOptionalServiceInput: AddOptionalServiceInput!) {
          addOptionalService(addOptionalService: $addOptionalServiceInput) {
            success
          }
        }`,
        variables: {
          addOptionalServiceInput: {
            identifier: serviceOptionId
          }
        }
      }).then((response) => {
        return response.data.addOptionalService.success
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async removeOptionalService ({ commit, state, getters, rootGetters }, { serviceOptionId }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation removeOptionalService($removeOptionalServiceInput: RemoveOptionalServiceInput!) {
          removeOptionalService(removeOptionalService: $removeOptionalServiceInput) {
            success
          }
        }`,
        variables: {
          removeOptionalServiceInput: {
            identifier: serviceOptionId
          }
        }
      }).then((response) => {
        return response.data.removeOptionalService.success
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async changeServiceOptions ({ commit, state, getters, rootGetters }, { anonymousCallRejection }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation serviceOptions($changeServiceOptionsInput: ChangeServiceOptionsInput!) {
          changeServiceOptions(changeServiceOptions: $changeServiceOptionsInput) {
            success
          }
        }`,
        variables: {
          changeServiceOptionsInput: {
            anonymousCallRejection: anonymousCallRejection
          }
        }
      }).then((response) => {
        return response.data.changeServiceOptions.success
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async loadRoamingCountries ({ commit }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.query({
        query: gql`query roamingCountries {
          roamingCountries
            {
              country,
              eu
            }
        }`
      }).then((response) => {
        commit('setRoamingCountries', response.data?.roamingCountries)
        commit('setEURoamingCountries', response.data?.roamingCountries)
        return true
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
        return false
      })
    }
  },
  mutations: {
    processId (state, id) {
      state.processId = id
    },
    incBookedOptionUpdateTriggerValue: (state) => {
      state.bookedOptionUpdateTriggerValue++
    },
    setRoamingCountries (state, countries) {
      const filteredRoamingCountries = countries.filter(country => country.eu === false)
      state.roamingCountries = filteredRoamingCountries
    },
    setEURoamingCountries (state, countries) {
      const filteredEUCountries = countries.filter(country => country.eu === true)
      state.euRoamingCountries = filteredEUCountries
    }
  },
  getters: {
    processId: state => {
      return state.processId
    },
    bookedOptionUpdateTriggerValue: state => {
      return state.bookedOptionUpdateTriggerValue
    },
    getRoamingCountries: state => {
      return state.roamingCountries
    },
    getEURoamingCountries: state => {
      return state.euRoamingCountries
    }
  }
}

export {
  TariffOptionsModule
}
